import React, { useCallback, useEffect, useState } from 'react'
import { useWorkStateFields } from '../../store/hooks';
import { getClassObj } from '../../store/workRefs';
import Masonry from "react-masonry-css";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faArrowRight, faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { faCircleCheck as hollowCheck } from "@fortawesome/free-regular-svg-icons";
import { get_liked_data_is_downloadable, get_selected_workId, sort_data_by_is_downloadable } from "./work_utils.js";
import {
     photos, guestUpload, albumSelection, blacklistReview, userFolders, hide,
    download, deleteUploads, approvePhoto, addTo,
    privatePhotos, publicPhotos, grid_version_1, grid_version_2, past_face_searches,
    allPhotos
} from "../../context/workConstants";
import noData from '../../images/no_data.png'
import { globalLoader, get_platform_bg_color, getMobileOperatingSystem, get_platform_action_color } from "../../script/util";
import './WorkDetails.css';

const MasonryGrid = ({ handleNextCollection, galleryHandler, selectionTypeData, returnFilteredData, paginationLoading, tileLimit = Infinity, onTileCounts }) => {
    const queryParams = new URLSearchParams(window.location.search);
    const tab = queryParams.get("tab")
    const showTrash = queryParams.get("trash")
    const collection_id = queryParams.get("work_id")
    var faceSearchOnly = queryParams.get('face_only') === 'true'

    var currentIndex = 0;
    const {
        collection, collectionFormattedData, currentDimensions, setShowGallery, loading, selection, selectedImages, selectImages, hideSelection, 
        downloadSelection, deleteSelection, approveFlagSelection, addToSelection, printSelection, hideSelectedObj, selectedOption, allGuestPhotos,
        yourUploads, nextCollectionName, faceSearchData, faceSearchOn, faceFormattedData,  faceSelect, faceHide, userFolderData, printSelectedData,
        nextCollection, filterWorkId, setSelectionAll, setSelectImages, isSelecting, setFaceSelect, images,
        setSelectedImages, setAlbumData, defAlbumData, multipleSelect, setMultipleSelect, collectionData
    } = useWorkStateFields(['collection', 'collectionFormattedData', 'currentDimensions', 'loading', 'selection', 'selectedImages', 'selectImages', 'hideSelection', 'downloadSelection', 'deleteSelection', 'approveFlagSelection', 'addToSelection', 'printSelection', 'hideSelectedObj', 'selectedOption', 'allGuestPhotos', 'yourUploads', 'nextCollectionName', 'faceSearchData', 'faceSearchOn', 'faceFormattedData', 'faceSelect', 'faceHide', 'userFolderData', 'printSelectedData', 'nextCollection', 'filterWorkId', 'images', 'defAlbumData', 'multipleSelect', 'collectionData']);
    // Read only here. In the shared store, every image's onLoad dispatched + notified every
    // subscriber and re-rendered the whole grid - 2.5x slower thumbnail loading on big collections.
    const [loadedImages, setLoadedImages] = useState({});
    const breakpointColumnsObj = collection?.thumbnail_version === 1 ? grid_version_1 : grid_version_2;

    // Thumbnails that finished, loaded or failed, by url. Until one does its tile is only its padding
    // tall, so on a slow network the grid's end (and the next-collection button) sits far too high.
    const [settledThumbs, setSettledThumbs] = useState({});
    const handleThumbSettled = (url) => {
        setSettledThumbs((prev) => (prev[url] ? prev : { ...prev, [url]: true }));
    };

    const handleImageLoad = (index, url) => {
        setLoadedImages((prev) => ({ ...prev, [index]: true }));
        handleThumbSettled(url);
    };

    const getDataByOption = (ele, selectedOption) => {
        const normalizedFilterWorkIds = new Set(filterWorkId.map(String));
        const applyFilterWorkId = (data) => {
            if (!filterWorkId.length) return data;
            return data.filter((e) => {
                const selectedData = faceSearchOn ? faceFormattedData : collectionFormattedData;
                const workId = String(get_selected_workId(selectedData, e.photo_id));
                return normalizedFilterWorkIds.has(workId);
            });
        };

        if(faceSearchOn){
            switch (selectedOption) {
                case privatePhotos:
                    return applyFilterWorkId(faceHide[ele?.work_id]);
                case publicPhotos:
                    var publicfacephotos = ele?.data.filter(obj1 => !faceHide[ele?.work_id].some(obj2 => obj2.photo_id === obj1.photo_id));
                    return applyFilterWorkId(publicfacephotos)
                default:
                    return applyFilterWorkId(ele?.data)
            }
        }else{
            switch (selectedOption) {
                case privatePhotos:
                    const refrenceObj = new Set(yourUploads?.map(item => item?.photo_id));
                    const filteredArray = hideSelectedObj[ele?.work_id]?.filter(item => refrenceObj.has(item?.photo_id));
                    const unsortedPrivateData = (allGuestPhotos ? (tab==userFolders ? ele.private_data : hideSelectedObj[ele?.work_id]) : filteredArray)
                    const sortedPrivateData = sort_data_by_is_downloadable(unsortedPrivateData, collection ,collectionFormattedData)
                    var privateDataToReturn = tab == userFolders && selection ? sortedPrivateData : unsortedPrivateData;
                  return applyFilterWorkId(privateDataToReturn)
                case publicPhotos:
                    const unsortedPublicData = (allGuestPhotos ? ele?.data : ele?.my_uploads).filter(obj1 => !(tab==userFolders ? ele.private_data : hideSelectedObj[ele?.work_id]).some(obj2 => obj2.photo_id === obj1.photo_id))
                    const sortePublicdData = sort_data_by_is_downloadable(unsortedPublicData, collection ,collectionFormattedData)
                    var publicDataToReturn = tab == userFolders && selection ? sortePublicdData : unsortedPublicData;
                  return applyFilterWorkId(publicDataToReturn)
                default:
                    const unsortedData = tab==photos ? images : (allGuestPhotos ? ele?.data : ele?.my_uploads)
                    const sortedData = sort_data_by_is_downloadable(unsortedData, collection ,collectionFormattedData)
                    var dataToReturn = tab == userFolders && downloadSelection ? sortedData : unsortedData;
                  return applyFilterWorkId(dataToReturn)
            }
        }
    }

    const addAndRemove = useCallback((work_id, photo_obj, updatedData) => {
        setMultipleSelect((prevMultipleSelect) => {
            return prevMultipleSelect.map((item) => {
                if (item.work_id == work_id) {
                    const isInSelect = updatedData?.some((i) => i === photo_obj.photo_id);
                    if (!isInSelect) {
                        return {
                            ...item,
                            select_list: item.select_list.filter((e) => e !== photo_obj.photo_id),
                            unselect_list: [...item.unselect_list, photo_obj.photo_id],
                        };
                    } 
                    else{
                        return {
                            ...item,
                            unselect_list: item.unselect_list.filter((e) => e !== photo_obj.photo_id),
                            select_list: item.select_list.includes(photo_obj.photo_id)
                                ? item.select_list
                                : [...item.select_list, photo_obj.photo_id],
                        };
                    }
                }
                return item;
            });
        });
    }, []);

    const updateSingleSelect = useCallback((work_id, photo_obj, updatedData) => {
        work_id = Number(work_id)
        const index = multipleSelect.findIndex((obj) => obj.work_id == work_id);
        if (index !== -1) {
            addAndRemove(work_id, photo_obj, updatedData);
        } else {
            setMultipleSelect((prevMultipleSelect) => [
                ...prevMultipleSelect,
                {
                    work_id,
                    select_list: [],
                    unselect_list: [],
                },
            ]);
            addAndRemove(work_id, photo_obj, updatedData);
        }
    }, [multipleSelect, hideSelectedObj, collectionData]);

    const toggleSelectImage = (photo_obj='') => {
        isSelecting.current = false;
        if(downloadSelection && tab==userFolders && !get_liked_data_is_downloadable(collection, collectionFormattedData, photo_obj))return;
        const selectedData = faceSearchOn ? faceFormattedData : collectionFormattedData


        const selectedWorkId = get_selected_workId(selectedData, photo_obj?.photo_id)
        var currentSelected;
        if(hideSelection){
            currentSelected = selectionTypeData(hide, selectedWorkId)
        }else if(downloadSelection){
            currentSelected = selectionTypeData(download, selectedWorkId)
        }else if(addToSelection){
            currentSelected = selectionTypeData(addTo, selectedWorkId)
        }else if(deleteSelection){
            currentSelected = selectionTypeData(deleteUploads, selectedWorkId)
        }else if(approveFlagSelection){
            currentSelected = selectionTypeData(approvePhoto, selectedWorkId)
        }
        const clonedCurrentSelected = JSON.parse(JSON.stringify(currentSelected))
        const updatedObj = getClassObj().updateSelectedArray({[collection_id]: (faceSearchOn ? clonedCurrentSelected : clonedCurrentSelected[collection_id])}, photo_obj, selectedWorkId);
        if(faceSearchOn){
            !downloadSelection && !deleteSelection && setFaceSelect(prevSelectedImages => ({
            ...prevSelectedImages,
            [selectedWorkId]: hideSelection && selectedOption == publicPhotos
                ? [...new Set([...(prevSelectedImages[selectedWorkId] || []), ...(updatedObj[selectedWorkId] || [])])]
                : updatedObj[selectedWorkId]
            }));
            const totalItems = Object.values(updatedObj).reduce((sum, arr) => sum + arr.length, 0)
            const filteredResult = Object.keys(updatedObj).reduce((total, key) => {
                const obj2PhotoIds = new Set(faceHide[key]?.map((item) => item.photo_id) || []);
                const filteredArray = updatedObj[key].filter((item) => !obj2PhotoIds.has(item.photo_id));
                return total + filteredArray.length;
              }, 0);
            setSelectionAll(prevState => ({
                ...prevState,
                [collection_id]: (selectedOption==publicPhotos ? filteredResult : totalItems) === Object.values(returnFilteredData()).flat().length
            }));
        }else{
            !downloadSelection && !deleteSelection && !approveFlagSelection && setSelectedImages(prevSelectedImages => ({
            ...prevSelectedImages,
            [selectedWorkId]: updatedObj[selectedWorkId]
            }));
        }
        (downloadSelection || addToSelection || deleteSelection || approveFlagSelection) && setSelectImages((prev) => {
            const updatedSelectImages = { ...prev };
            if(!isSelecting.current){
                isSelecting.current = true;
                if(!(Object.values(selectImages || {}).map(collection => collection?.[selectedWorkId]).filter(Boolean).flat())?.some(el =>el.photo_id == photo_obj.photo_id)){
                    if(!updatedSelectImages[collection_id][selectedWorkId]){
                        updatedSelectImages[collection_id][selectedWorkId] = [photo_obj];
                    }else{
                        updatedSelectImages[collection_id][selectedWorkId].push(photo_obj);
                    }
                }else{
                    Object.keys(updatedSelectImages).forEach((cid) => {
                        if (updatedSelectImages[cid]?.[selectedWorkId]) {
                            updatedSelectImages[cid][selectedWorkId] = updatedSelectImages[cid][selectedWorkId].filter(
                                (item) => item.photo_id !== photo_obj.photo_id
                            );
                        }
                    });
                }
            }
            return {
                ...updatedSelectImages,
                [collection_id]: {
                ...updatedSelectImages[collection_id],
                [selectedWorkId]: updatedSelectImages[collection_id][selectedWorkId],
                },
            };
        });
        if (!clonedCurrentSelected[selectedWorkId]) {
            clonedCurrentSelected[selectedWorkId] = [];
        }
        // After Select all this holds photo objects rather than ids, in every mode; the lookup
        // below needs ids, or the first tap would select instead of unselect.
        const normalize = (item) =>
            item && typeof item === 'object' ? item.photo_id : item;
        clonedCurrentSelected[selectedWorkId] = [
            ...new Set([
                ...clonedCurrentSelected[selectedWorkId].map(normalize),
            ]),
        ];

        const index = clonedCurrentSelected[selectedWorkId].indexOf(photo_obj.photo_id);
        if (index === -1) {
            clonedCurrentSelected[selectedWorkId].push(photo_obj.photo_id);
        } else {
            clonedCurrentSelected[selectedWorkId].splice(index, 1); 
        }
        updateSingleSelect(selectedWorkId, photo_obj, clonedCurrentSelected[selectedWorkId])
        let tempData = defAlbumData;
        tempData && setAlbumData(JSON.parse(JSON.stringify(tempData))); // Create a deep copy
    };

    // Tiles the grid would show without the window; the next-collection button waits for all of them
    // and for every thumbnail to have settled, so it only shows at the grid's real end.
    const gridSource = (!faceSearchOn) ? (tab==userFolders ? userFolderData : collection?.photo_data) : faceSearchData?.photo_data
    const tileLists = (gridSource || []).map((ele) => getDataByOption(ele, selectedOption) || [])
    const totalTiles = tileLists.reduce((sum, list) => sum + list.length, 0)
    const allTilesShown = totalTiles <= tileLimit &&
        tileLists.every((list) => list.every((e) => !e?.thumb_url || settledThumbs[e.thumb_url]))
    const gridShown = (tab==photos || tab==guestUpload || tab==albumSelection || tab==userFolders || faceSearchOnly || tab == blacklistReview || tab == past_face_searches) && !showTrash && (faceSearchData?.photo_data || collection?.photo_data)
    const tilesShown = gridShown && (faceSearchOn ? faceSearchData?.photo_count > 0 : (allGuestPhotos ? collection?.photo_count > 0 : yourUploads.length > 0))

    // Selection reads these rather than the DOM, since the grid only draws a window of the tiles:
    // every tile, the ones that can't be selected, and the ones checked.
    const getTileCounts = () => {
        if (!tilesShown) return { drawn: 0, total: 0, blocked: 0, checked: 0 }
        const checking = downloadSelection || addToSelection || deleteSelection || approveFlagSelection
        let workIdByPhoto
        const workIdOf = (photo) => {
            if (!workIdByPhoto) {
                // same lookup as get_selected_workId, built once instead of per tile
                workIdByPhoto = new Map()
                const formatted = (faceSearchOn ? faceFormattedData : collectionFormattedData) || {}
                Object.keys(formatted).forEach((key) => (formatted[key] || []).forEach((p) => {
                    if (!workIdByPhoto.has(p?.photo_id)) workIdByPhoto.set(p?.photo_id, Number(key))
                }))
            }
            return workIdByPhoto.has(photo?.photo_id) ? workIdByPhoto.get(photo.photo_id) : NaN
        }
        const checkedIdsByWork = new Map()
        const isChecked = (photo) => {
            const workId = workIdOf(photo)
            if (!checkedIdsByWork.has(workId)) {
                checkedIdsByWork.set(workId, new Set(Object.values(selectImages || {})
                    .map((c) => c?.[workId]).filter(Boolean).flat().map((el) => String(el?.photo_id))))
            }
            return checkedIdsByWork.get(workId).has(String(photo?.photo_id))
        }
        let blocked = 0
        let checked = 0
        // outside these modes no tile is blocked or checked
        if (selection || checking || downloadSelection || printSelection) tileLists.forEach((list) => list.forEach((e) => {
            // the tiles that get a notDeleteOverlay
            if ((selection && e?.processing) ||
                (tab === userFolders && downloadSelection && !(collection?.photo_data || []).find((obj) => obj.work_id === workIdOf(e))?.is_downloadable) ||
                (tab === userFolders && printSelection && addToSelection && !printSelectedData?.work_id_list?.includes(workIdOf(e)))) blocked++
            if (checking && selectImages && isChecked(e)) checked++
        }))
        return { drawn: Math.min(totalTiles, tileLimit), total: totalTiles, blocked, checked }
    }

    useEffect(() => {
        onTileCounts?.(getTileCounts())
    })

    return (
        <>
            {gridShown ? <div style={{paddingBottom:currentDimensions < 600 ? "50%" : '10%'}}>
                <div style={{display: document.getElementsByClassName('my-masonry-grid_column').length==0 && 'flex', justifyContent:"center"}} >
                {tilesShown && (
                    gridSource?.map((ele, index) => (
                        <div key={index}>
                            {tileLists[index].length > 0 && (faceSearchOn || tab==albumSelection) && (
                                <div className="searchCollectionTitle">
                                    {ele.title}{ele?.desc && selection && <span style={{fontSize:"small", color:"grey"}}> - ({ele?.desc})</span>}
                                </div>
                            )}
                            <div style={{position:"relative", display: (((faceSearchOn ? faceHide[ele.work_id] : hideSelectedObj[ele.work_id])?.length==0 && selectedOption==privatePhotos) || ((ele._photo_count-(faceSearchOn ? faceHide[ele.work_id] : hideSelectedObj[ele.work_id])?.length)==0 && selectedOption==publicPhotos)) && 'none'}}>
                                {(!(ele.can_add_to || ele.is_album_required) && addToSelection) && tab!==userFolders && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                background: "rgba(0,0,0,0.7)",
                                                width: "100%",
                                                height: "100%",
                                                zIndex: 9,
                                                bottom: 0,
                                                color:"white",
                                                display:"flex",
                                                alignItems:"center",
                                                justifyContent:"center",
                                            }}
                                        ><p style={{background:"rgba(0,0,0,0.9)", padding:"5px 10px", borderRadius:"5px"}}><FontAwesomeIcon icon={faCircleInfo} style={{color: get_platform_bg_color(),}} /> Collection can't be selected!</p></div>
                                )}
                                {(!(ele.can_make_private) && hideSelection) && tab!==userFolders && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                background: "rgba(0,0,0,0.7)",
                                                width: "100%",
                                                height: "100%",
                                                zIndex: 9,
                                                bottom: 0,
                                                color:"white",
                                                display:"flex",
                                                alignItems:"center",
                                                justifyContent:"center",
                                            }}
                                        ><p style={{background:"rgba(0,0,0,0.9)", padding:"5px 10px", borderRadius:"5px"}}><FontAwesomeIcon icon={faCircleInfo} style={{color: get_platform_bg_color(),}} /> Collection can't be hidden!</p></div>
                                )}
                                {(!(ele.is_downloadable) && downloadSelection) && tab!==userFolders && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                background: "rgba(0,0,0,0.7)",
                                                width: "100%",
                                                height: "100%",
                                                zIndex: 9,
                                                bottom: 0,
                                                color:"white",
                                                display:"flex",
                                                alignItems:"center",
                                                justifyContent:"center",
                                            }}
                                        ><p style={{background:"rgba(0,0,0,0.9)", padding:"5px 10px", borderRadius:"5px"}}><FontAwesomeIcon icon={faCircleInfo} style={{color: get_platform_bg_color(),}} /> Collection is not downloadable!</p></div>
                                )}
                                <Masonry
                                key={index}
                                breakpointCols={breakpointColumnsObj}
                                className="my-masonry-grid"
                                columnClassName="my-masonry-grid_column"
                                style={{position:"relative"}}
                                >
                                {tileLists[index].slice(0, Math.max(0, tileLimit - currentIndex)).map((e, idx) => {
                                    const localIndex = currentIndex++;
                                    return (
                                        <a style={{pointerEvents:((!(ele.can_add_to || ele.is_album_required) && addToSelection && tab!==userFolders) || 
                                            (tab==userFolders && printSelection && addToSelection && !printSelectedData?.work_id_list?.includes(get_selected_workId(collectionFormattedData, e?.photo_id)))) && 'none'}} key={currentIndex} href={`#gallery?index=${currentIndex}`} onClick={()=>{!selection && setShowGallery(true)}}>
                                            <div
                                                id={`gallery${currentIndex}`}
                                                style={{ position: "relative" }}
                                                onClick={(event) => {
                                                if (selection) {
                                                    event.preventDefault();
                                                    !e.processing && toggleSelectImage(e);
                                                }
                                                }}
                                            >
                                                <img
                                                id={`${currentIndex}`}
                                                style={{
                                                    display: "block",
                                                    width: "100%",
                                                    padding: "2.5px",
                                                }}
                                                src={e.thumb_url}
                                                onClick={galleryHandler}
                                                onLoad={() => handleImageLoad(localIndex, e.thumb_url)}
                                                onError={() => handleThumbSettled(e.thumb_url)}
                                                alt={`Thumbnail ${currentIndex}`}
                                                />
                                                {(tab==guestUpload || tab==blacklistReview) && loadedImages[localIndex] && <div id='guestName'>{(e?.user_full_name?.length>14 ? e.user_full_name.slice(0, 14)+'...' : e?.user_full_name)}</div>}
                                                {selection && e?.processing && <div className='notDeleteOverlay'>
                                                    <p style={{background:"rgba(0,0,0,0.9)", padding:"5px 10px", borderRadius:"5px"}}><FontAwesomeIcon icon={faCircleInfo} style={{color: get_platform_bg_color(),}} /> Processing!</p>
                                                </div>}
                                                {tab==userFolders && downloadSelection && loadedImages[localIndex] && !get_liked_data_is_downloadable(collection, collectionFormattedData, e) && <div className='notDeleteOverlay'>
                                                    <p style={{background:"rgba(0,0,0,0.9)", padding:"5px 10px", borderRadius:"5px"}}><FontAwesomeIcon icon={faCircleInfo} style={{color: get_platform_bg_color(),}} /> Can't be downloaded!</p>
                                                </div>}
                                                {tab==userFolders && printSelection && addToSelection && loadedImages[localIndex] && !printSelectedData?.work_id_list?.includes(get_selected_workId(collectionFormattedData, e?.photo_id)) &&  <div className='notDeleteOverlay'>
                                                    <p style={{background:"rgba(0,0,0,0.9)", padding:"5px 10px", borderRadius:"5px"}}><FontAwesomeIcon icon={faCircleInfo} style={{color: get_platform_bg_color(),}} /> Can't be selected</p>
                                                </div>}
                                                {!(downloadSelection || addToSelection || deleteSelection || approveFlagSelection) ? (hideSelection || (faceSearchOn ? faceHide[ele.work_id] : (tab==userFolders ? hideSelectedObj[get_selected_workId(collectionFormattedData, e?.photo_id)] : hideSelectedObj[ele.work_id]))?.some(el =>el.photo_id == e.photo_id)) && (
                                                <div
                                                    style={{
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    width: hideSelection ? "100%" : undefined,
                                                    height: hideSelection ? "100%" : undefined,
                                                    backgroundColor: hideSelection ? "rgba(0,0,0,0.5)" : undefined,
                                                    zIndex: hideSelection ? 1 : undefined,
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                    justifyContent: "flex-start",
                                                    transition: "opacity 0.3s ease",
                                                    }}
                                                >
                                                    {(faceSearchOn ? faceSelect[ele.work_id] : (tab==userFolders ? selectedImages[get_selected_workId(collectionFormattedData, e?.photo_id)] : selectedImages[ele.work_id]))?.some(el =>el.photo_id == e.photo_id) ? (
                                                    (loadedImages[localIndex] && <img
                                                        className="hideImage"
                                                        style={{
                                                        width: "30px",
                                                        margin: currentDimensions>600 ? "20px" : "12px",
                                                        pointerEvents: hideSelection ? 'none' : undefined,
                                                        filter: "drop-shadow(0px 0px 6px #fff)",
                                                        }}
                                                        src="https://assets.graphia.in/site_media/webapp/red_eye.png"
                                                        alt="Selected"
                                                    />)
                                                    ) : (
                                                    (loadedImages[localIndex] && <img
                                                        style={{
                                                        width: "30px",
                                                        margin: currentDimensions>600 ? "20px" : "12px",
                                                        pointerEvents: hideSelection ? 'none' : undefined,
                                                        filter: "drop-shadow(0px 0px 6px #fff)",
                                                        }}
                                                        src="https://assets.graphia.in/site_media/webapp/white_eye.png"
                                                        alt="Not Selected"
                                                    />)
                                                    )}
                                                </div>
                                                ) : <div
                                                style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: (downloadSelection || addToSelection || deleteSelection || approveFlagSelection) ? "100%" : undefined,
                                                height: (downloadSelection || addToSelection || deleteSelection || approveFlagSelection) ? "100%" : undefined,
                                                backgroundColor: (downloadSelection || addToSelection || deleteSelection || approveFlagSelection) ? "rgba(0,0,0,0.5)" : undefined,
                                                zIndex: (downloadSelection || addToSelection || deleteSelection || approveFlagSelection) ? 1 : undefined,
                                                display: "flex",
                                                alignItems: "flex-start",
                                                justifyContent: "flex-start",
                                                transition: "opacity 0.3s ease",
                                                }}
                                            >   
                                                {selectImages && (Object.values(selectImages || {}).map(collection => collection?.[get_selected_workId(faceSearchOn ? faceFormattedData : collectionFormattedData, e?.photo_id)]).filter(Boolean).flat())?.some(el =>el.photo_id == e.photo_id) ? (
                                                    <FontAwesomeIcon className="checkedImage" size='lg' icon={faCircleCheck} style={{color: get_platform_action_color(), margin:currentDimensions>600 ? "20px" : "12px",pointerEvents: downloadSelection && 'none', backgroundColor:"white", borderRadius:"50%"}} />
                                                ) : (
                                                    <FontAwesomeIcon size='lg' icon={hollowCheck} style={{color: "#ffffff", margin:currentDimensions>600 ? "20px" : "12px",pointerEvents: downloadSelection && 'none'}} />
                                                )}
                                            </div>}
                                        </div>
                                        </a>
                                    )
                                })}
                                </Masonry>
                            </div>
                        </div>
                    ))
                )}
                {( 
                    selectedOption==allPhotos ? (faceSearchOn ? faceSearchData?.photo_count : (allGuestPhotos ? collection?.photo_count : yourUploads.length)) == 0 : document.getElementsByClassName('my-masonry-grid_column').length==0
                ) && (
                    <div style={{display:"flex", flexDirection:"column",   justifyContent:"center", alignItems:"center", height:"60vh"}}>
                        <img className='noDataImage' src={noData} alt='no data found'/>
                        <div style={{fontSize:"larger", fontWeight:"600", color:"#656363"}}>No data found!</div>
                    </div>
                )}
                </div>
            {loading && <div style={{padding:"5%"}}>{globalLoader()}</div>}
            {nextCollection && !loading && nextCollectionName && !faceSearchOn && !paginationLoading && allTilesShown && <div className="nextCollectionDiv" style={{paddingBottom: getMobileOperatingSystem()=="iOS" && '35%'}}><button className="nextCollection" onClick={()=>handleNextCollection(true)}>{nextCollectionName} <FontAwesomeIcon icon={faArrowRight} style={{color: "#ffffff",}} size="sm"/></button></div>}</div> :
            <div className="skeleton-grid" style={{display: !(queryParams.get('tab') === photos || queryParams.get('tab') === guestUpload || queryParams.get('tab') === albumSelection || (queryParams.get('tab') === userFolders && !showTrash) || queryParams.get('tab') === blacklistReview || queryParams.get('tab') === past_face_searches) && 'none'}}>
                {[...Array(24)].map((_, index) => (
                <div key={index} className="skeleton-item">
                    <Skeleton height={350} />
                </div>
                ))}
            </div>}
        </>
    )
}

export default MasonryGrid